import { mapState, mapActions } from 'vuex'
import RouterName from '@/constants/route'
import { upload } from '@/mixin/file'
import { ProgrammeType } from '@/constants/type'
import Actions from '@/constants/action'
import { loading } from '@/mixin'
import { next } from '@/mixin/index'
import { term } from '@/components/PwcTerm/mixin/term'
import { dateYMD } from '@/util/date'
const RequiredBaseFormItem = {
  'name': true,
  'email': true,
  'age': true,
  'eduInstitution': true,
  'major': true,
  'grade': true,
  'birthDay': true,
  'registerFromCityId': false,
  'fcpId': false
}
const Required_10 = {
  'birthDay': true,
  'activitiesOnCampus': false,
  'activitiesOffCampus': false,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false
}
const Required_11 = {
  'gpa': true,
  'birthDay': true,
  'activitiesOnCampus': false,
  'activitiesOffCampus': false,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false

  // 'activitiesOnCampus1': true,
  // 'activitiesOnCampus2': false,
  // 'activitiesOnCampus3': true,
  // 'activitiesOnCampus4': true,

  // 'activitiesOffCampus1': true,
  // 'activitiesOffCampus2': false,
  // 'activitiesOffCampus3': true,
  // 'activitiesOffCampus4': true
}
const Required_12 = {
  'classId': true,
  'birthDay': true,
  'cityId': false,
  'activitiesOnCampus': false,
  'activitiesOffCampus': false,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false
}
const Required_13 = {
  'classId': true,
  'birthDay': true,
  'cityId': false,
  'gpa': true,
  'activitiesOnCampus': true,
  'activitiesOffCampus': true,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false

  // 'activitiesOnCampus1': true,
  // 'activitiesOnCampus2': false,
  // 'activitiesOnCampus3': true,
  // 'activitiesOnCampus4': true,

  // 'activitiesOffCampus1': true,
  // 'activitiesOffCampus2': false,
  // 'activitiesOffCampus3': true,
  // 'activitiesOffCampus4': true
}
const Required_14 = {
  'classId': true,
  'birthDay': true,
  'cityId': false,
  'gpa': true,
  'activitiesOnCampus': false,
  'activitiesOffCampus': false,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false
}

const Required_15 = {
  'birthDay': true,
  'classId': false,
  'cityId': false,
  'activitiesOnCampus': false,
  'activitiesOffCampus': false,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false,
  'parentSupportReason': true,
  'familyExpect': false
}

const Required_16 = {
  'birthDay': true,
  'classId': true,
  'cityId': false,
  'activitiesOnCampus': false,
  'activitiesOffCampus': false,
  'refereeTypeId': false,
  'refereeName': false,
  'fcpId': false,
  'parentSupportReason': true,
  'familyExpect': false
}

const separator = '--'

const CityOtherId = 'd6e109d9-cbe7-11e9-ad67-00163e0255bb'

const formTypeMap = {
  'f10': Required_10,
  'f11': Required_11,
  'f12': Required_12,
  'f13': Required_13,
  'f14': Required_14,
  'f15': Required_15,
  'f16': Required_16
}

const usroadshowfcps = {
  'fcps': []
}

export const logic = {
  mixins: [upload, loading, next, term],
  data() {
    return {
      /* if eventId exist, register this event*/
      eventId: this.$route.query.id,
      productId: this.$route.query.product,
      programmeType: this.$route.query.type,
      productName: this.$route.query.name,
      formType: this.$route.query.formType,
      campaignCode: this.$route.query.campaignCode,
      /* basic */
      name: '',
      age: '',
      email: '',
      profilePhotoUrl: '',

      /* for student */
      eduInstitution: '',
      grade: '',
      major: '',

      /* for worker */
      company: '',
      title: '',
      yearsOfWork: '',
      industryId: '',
      industryOther: '',

      /* for apply */
      classId: '',
      overseaRegionIds: '',
      gpa: '',
      activitiesOnCampus: '',
      activitiesOnCampus1: '',
      activitiesOnCampus2: '',
      activitiesOnCampus3: '',
      activitiesOnCampus4: '',

      activitiesOffCampus: '',
      activitiesOffCampus1: '',
      activitiesOffCampus2: '',
      activitiesOffCampus3: '',
      activitiesOffCampus4: '',
      acadamy: '',
      refereeTypeId: '',
      refereeName: '',
      submitDisabled: true,

      /* for city*/
      cityOtherName: '',
      cityId: '',
      registerFromCityId: '',
      fcpId: '',

      usroadshowfcps,
      parentSupportReason: [],
      familyExpect: '',
      birthDay: dateYMD(new Date(1970,0,1)),
      showDate: false,
      showTime: false,
      minDate: new Date(1970,0,1),
    }
  },
  created() {
    this.fetchLookups()
    this.fetchApplyLookups({
      campaignCode: this.campaignCode
    })
    this.getBaseInfo().then(res=>{
      if(res.resultCode ==='0'){
        if(res.leadBaseInfo.birthDay === '0001-01-01 00:00:00'){
          this.birthDay =  dateYMD(new Date(1970,0,1))
          console.log(this.birthDay,'123');
        }
      }
    })
    this.getAnchorApplyForm({
      productId: this.productId,
      campaignCode: this.campaignCode
    })
    
    if(this.birthDay === '0001-01-01 00:00:00'){
      this.birthDay =  dateYMD(new Date(1970,0,1))
      console.log(this.birthDay,'123');
    }
  },
  watch: {
    anchorForm() {
      this.updateComponentInfo()
    },
    userInfo() {
      this.updateComponentInfo()
    },
    cClassLookup(n) {
      if (n.classes.length === 1) {
        this.classId = n.classes[0].id
        this.cityId = this.applyLookups.cities[0].id
      }
    },
    cClass(n) {
      if (n && n.indexOf('2020') !== -1 && n.indexOf('跨年班') !== -1) {
        this.cityId = ''
        this.applyLookups.cities = this.applyLookups.cities.filter(v => v.id !== '782f3838-bda7-11e9-a169-00163e0255bb')
      } else {
        const gz = this.applyLookups.cities.filter(v => v.id === '782f3838-bda7-11e9-a169-00163e0255bb') || {}
        if (gz.length === 0) {
          this.applyLookups.cities.splice(2, 0, { id: '782f3838-bda7-11e9-a169-00163e0255bb', name: '广州', name_en: 'Guangzhou' })
        }
      }
    }
    // ,
    // cAcadamy(n) {
    //   if (!n) {
    //     return
    //   }
    //   const infos = n.split(separator)
    //   if (infos.length === 2) {
    //     this.eduInstitution = infos[0]
    //     this.acadamy = infos[1]
    //   }
    // }
    // activitiesOnCampus(n) {
    //   if (!n) {
    //     return
    //   }

    //   const infos = n.split(separator)
    //   if (infos.length === 4) {
    //     this.activitiesOnCampus1 = infos[0]
    //     this.activitiesOnCampus2 = infos[1]
    //     this.activitiesOnCampus3 = infos[2]
    //     this.activitiesOnCampus4 = infos[3]
    //   }
    // },
    // activitiesOffCampus(n) {
    //   if (!n) {
    //     return
    //   }

    //   const infos = n.split(separator)
    //   if (infos.length === 4) {
    //     this.activitiesOffCampus1 = infos[0]
    //     this.activitiesOffCampus2 = infos[1]
    //     this.activitiesOffCampus3 = infos[2]
    //     this.activitiesOffCampus4 = infos[3]
    //   }
    // }
  },
  computed: {
    ...mapState([
      'userInfo',
      'loading',
      'lookups',
      'applyLookups',
      'anchorForm'
    ]),
    cTitle() {
      return this.formType === 'f14' ? `信息登记表` : `申请表单`
    },
    cClasslable() {
      return this.formType === 'f14' ? `您感兴趣的课程?` : `您希望参加哪一期的课程?`
    },
    cLoading() {
      return this.loading.userInfoLoading || this.loading.anchorFormLoading
    },
    cShowEducation() {
      return Number(this.programmeType) === ProgrammeType.Anchor
    },
    cShowWorkInfo() {
      return Number(this.programmeType) === ProgrammeType.YouPlus
    },
    cShowF10() {
      return this.formType === 'f10'
    },
    cShowF11() {
      return this.formType === 'f11'
    },
    cShowF12() {
      return this.formType === 'f12'
    },
    cShowF13() {
      return this.formType === 'f13'
    },
    cShowF14() {
      return this.formType === 'f14'
    },
    cShowF15() {
      return this.formType === 'f15'
    },
    cShowF16() {
      return this.formType === 'f16'
    },
    cAnchorApplySubmited() {
      return this.anchorForm.isSubmitted
    },
    cClassLookup() {
      const product = (this.applyLookups.products || []).find(v => v.id === this.productId)
      const formatLookup = {
        classes: []
      }
      if (product) {
        formatLookup.classes = product.classes
      }
      return formatLookup
    },
    cInnerIntro() {
      // applicationFormDesc
      const product = (this.applyLookups.products || []).find(v => v.id === this.productId)
      if (product) {
        return product.applicationFormDesc
      }
    },
    cShowOtherCityField() {
      return this.cityId === CityOtherId
    },
    cIsAcadamyReqired() {
      if (this.eduInstitution === '重庆大学' || this.eduInstitution === '重大') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    handleDialogConfirm(cb) {
      // component implemented
    },
    handleDialogMessage(msg) {
      // component implemented
    },
    ...mapActions({
      updateUserInfo: Actions.UPDATE_USER_INFO,
      fetchLookups: Actions.GET_LOOKUP,
      fetchApplyLookups: Actions.GET_APPLY_LOOKUPS,
      getBaseInfo: Actions.GET_BASE_INFO,
      getAnchorApplyForm: Actions.GET_ANCHOR_APPLICATION_FORM,
      saveAnchorForm: Actions.SAVE_ANCHOR_APPLICATION,
      submitAnchorForm: Actions.SUBMIT_ANCHOR_APPLICATION
    }),
    handleCheck() {
      const formItemInfo = formTypeMap[this.formType]
      const keys = Object.keys(formItemInfo).concat(...Object.keys(RequiredBaseFormItem))
      let validate = true
      if (!this.cShowWorkInfo) {
        for (let i = 0; i < keys.length; i++) {
          if ((formItemInfo[keys[i]] || RequiredBaseFormItem[keys[i]]) && ((Array.isArray(this[keys[i]]) && this[keys[i]].length < 1) || (!Array.isArray(this[keys[i]]) && !this[keys[i]]))) {
            validate = false
            break
          }
        }
      } else {
        let msg = ``

        if (!this.name) {
          // master input name
          msg += '请输入您的名字'
          // return this.handleDialogMessage('请输入您的名字')
        }
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!this.email || !pattern.test(this.email)) {
          // return this.handleDialogMessage('请输入正确的邮箱')
          msg += `\n 请输入正确的邮箱`
        }

        if (this.cShowWorkInfo && !this.company) {
          msg += `\n 请输入您的公司`
          // return this.handleDialogMessage('请输入您的公司')
        }
        if (this.cShowWorkInfo && !this.title) {
          msg += `\n 请输入您的职位`
          // return this.handleDialogMessage('请输入您的职位')
        }
        if (this.cShowWorkInfo && !this.yearsOfWork) {
          msg += `\n 请选择您的工作年限`
          // return this.handleDialogMessage('请选择您的工作年限')
        }
        if (this.cShowWorkInfo && !this.industryId) {
          // master input name
          msg += `\n 请选择您的行业`
          // return this.handleDialogMessage('请选择您的行业')
        }
        if (this.cIndustry === '其他' && !this.industryOther) {
          msg += `\n 请注明其他行业`
          // return this.handleDialogMessage('请注明其他行业')
        }
        if (msg.length > 0) {
          msg = msg.replace(/^\n/g, '')
          validate = false
        }
      }
      if (validate && !this.cAnchorApplySubmited) {
        this.submitDisabled = false
      } else {
        this.submitDisabled = true
      }
    },
    updateComponentInfo() {
      this.name = this.userInfo.name || ''
      this.age = this.userInfo.age || ''
      this.email = this.userInfo.email || ''
      this.birthDay = dateYMD(this.userInfo.birthDay) || new Date(1970,0,1)
      if (this.userInfo.eduInstitution) {
        const infos = this.userInfo.eduInstitution.split(separator)
        this.eduInstitution = infos[0]
        if (infos.length === 2) {
          this.acadamy = infos[1]
        }
      }

      this.grade = this.userInfo.grade
      this.major = this.userInfo.major

      this.company = this.userInfo.company
      this.title = this.userInfo.title
      this.yearsOfWork = this.userInfo.yearsOfWork
      this.industryId = this.userInfo.industryId
      this.industryOther = this.industryOther

      // anchorForm
      // this.classId = this.classId || this.anchorForm.classId
      this.classId = this.anchorForm.classId

      // this.cityId = this.cityId || this.anchorForm.cityId
      this.cityId = this.anchorForm.cityId

      this.overseaRegionIds =
      this.anchorForm.overseaRegionIds && this.anchorForm.overseaRegionIds[0]
      this.gpa = this.anchorForm.gpa || ''
      this.activitiesOnCampus = this.anchorForm.activitiesOnCampus
      this.activitiesOffCampus = this.anchorForm.activitiesOffCampus
      this.refereeTypeId = this.anchorForm.refereeTypeId
      this.refereeName = this.anchorForm.refereeName || ''
      this.cityOtherName = this.anchorForm.cityOtherName
      this.registerFromCityId = this.anchorForm.registerFromCityId
      this.fcpId = this.anchorForm.fcpId
      this.parentSupportReason = this.anchorForm.parentSupportReasons
      this.familyExpect = this.anchorForm.familyExpect
    },
    getAnchorApply() {
      const basic = {
        productId: this.productId,

        /* basic */
        name: this.name,
        age: this.age,
        email: this.email,
        birthDay: this.birthDay,
        // profilePhotoUrl: this.profilePhotoUrl,

        campaignCode: this.campaignCode
      }
      const education = {
        eduInstitution: this.cIsAcadamyReqired ? this.eduInstitution + separator + this.acadamy : this.eduInstitution,
        grade: this.grade,
        major: this.major
      }
      const work = {
        company: this.company,
        title: this.company,
        yearsOfWork: this.yearsOfWork,
        industryId: this.industryId,
        industryOther: this.industryOther

      }
      const apply = {
        classId: this.cClassLookup.classes.length > 1 ? this.classId || this.cClassLookup.classes[0].id : this.cClassLookup.classes[0].id,
        cityId: (this.cClass && this.cClass.indexOf('2020') !== -1 && this.cClass.indexOf('跨年班') !== -1 && this.cityId === '') ? '' : this.cityId || this.applyLookups.cities[0].id,
        overseaRegionIds: this.overseaRegionIds && [this.overseaRegionIds],
        gpa: this.gpa,
        activitiesOnCampus: this.activitiesOnCampus,
        // [
        //   this.activitiesOnCampus1,
        //   this.activitiesOnCampus2,
        //   this.activitiesOnCampus3,
        //   this.activitiesOnCampus4
        // ].join(separator),
        activitiesOffCampus: this.activitiesOffCampus,
        // [
        //   this.activitiesOffCampus1,
        //   this.activitiesOffCampus2,
        //   this.activitiesOffCampus3,
        //   this.activitiesOffCampus4
        // ].join(separator),
        refereeName: this.refereeName || '',
        refereeTypeId: this.refereeTypeId,
        cityOtherName: this.cityOtherName,
        registerFromCityId: this.registerFromCityId,
        fcpId: this.fcpId,
        parentSupportReasons: this.parentSupportReason,
        familyExpect: this.familyExpect
      }

      const updateInfo = Object.assign(basic, education, work, apply)

      Object.keys(updateInfo).forEach(k => {
        if (!updateInfo[k]) {
          Reflect.deleteProperty(updateInfo, k)
        }
      })

      return updateInfo
    },
    handleSaveAnchorApply() {
      if (!this.name) {
        // master input name
        return this.handleDialogMessage('请输入名字')
      }
      this.saveAnchorForm(this.getAnchorApply())
    },
    handleSubmitAnchorApply() {
      if (this.cIsAcadamyReqired && !this.acadamy) {
        return this.handleDialogMessage('请填写学院')
      }
      if((this.cShowF11 || this. cShowF13 || this.cShowF14) && this.gpa){
        if(Number(this.gpa) >= 1000){
          return this.handleDialogMessage('请输入正确的GPA')
        }
        const reg = new RegExp("^(0(?!.0{1,2}$)(.[0-9]{1,2})?|[1-9][0-9]{0,2}(.[0-9]{1,2})?)$");
        if(!reg.test(this.gpa)) {
          return this.handleDialogMessage('请输入正确的GPA')
        }
      }
      const product = (this.applyLookups.products || []).find(
        v => v.id === this.productId
      )
      if (product && product.productTerm) {
        this.showTerm(product.productTerm)
      } else if (product) {
        this.handleConfirm()
      }
    },
    handleConfirm() {
      this.submitAnchorForm(this.getAnchorApply())
        .then((res) => {
          if (res.resultCode === '0') {
            this.handleDialogMessage('提交成功')
          }
          else {
            this.handleDialogMessage(res.resultMsg)
          }          
        })
    },
    handleReturn(isAlert) {
      if (isAlert) {
        return this.handleDialogConfirm(() => {
          this.goBack()
        })
      }
      this.goBack()
    },
    goBack() {
      this.$router.replace({
        name: RouterName.home,
        query: {
          active: 'document'
        }
      })
    },
    // changeFn(e){
    //   // this.birthDay = e
    //   debugger
    //   console.log(e,'e')
    // }
  }
}
